"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _OpenEnded = _interopRequireDefault(require("./OpenEnded"));
var _MultipleChoice = _interopRequireDefault(require("./MultipleChoice"));
var _Slider = _interopRequireDefault(require("./Slider"));
var _Checkbox = _interopRequireDefault(require("./Checkbox"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = {
  openEnded: _OpenEnded["default"],
  multipleChoice: _MultipleChoice["default"],
  slider: _Slider["default"],
  checkbox: _Checkbox["default"]
};